import { render, staticRenderFns } from "./DrawerFilterStrategies.vue?vue&type=template&id=40f0236c&scoped=true&"
import script from "./DrawerFilterStrategies.vue?vue&type=script&lang=js&"
export * from "./DrawerFilterStrategies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0236c",
  null
  
)

export default component.exports